const get = require('lodash/get')
const { listAll } = require('./list-all')
const { listProductsForPrograms } = require('./list-for-programs-services')
const utils = require('./../../utils')

const getProductsPSM = (state) => {
  const userPrograms = get(state, 'user.programs', [])
  return listProductsForPrograms(state, userPrograms)
}

const getProductsSL = (state) => listAll(state)

exports.exportProducts = async (state, opts) => {
  const isPSMUser = get(state, 'user.roles', []).includes('psm-user')
  const products = isPSMUser ? await getProductsPSM(state) : await getProductsSL(state)
  return utils.sheet.encode(products, opts)
}
